import React from 'react'

import EditIcon from '@mui/icons-material/Edit'
import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { DeleteIcon } from 'components/Icons'
import { useLoading, useException, useModal } from 'hooks'
import { IHandleChangeRowsPerPage, IHandleChangePage } from 'hooks/useGet'
import {
  IPaginatedEntityGST,
  IResponseTypes
} from 'services/core/genericEntityGST'
import {
  IGetAllSubItensResponse,
  IGetAllSubItensParams
} from 'services/GST/CadastroItensSubitensSeguranca'
import { CadastroSegurancaItensSubItensServices } from 'services/GST/CadastroItensSubitensSeguranca'

import { useSecurityItensAndSubItens } from '../../../../../../context'

interface ITableSubItensProps {
  data: IPaginatedEntityGST<IGetAllSubItensResponse[]>
  refresh: (_params: IGetAllSubItensParams) => void
  page: number
  rowsPerPage: number
  handleChangePage: IHandleChangePage
  handleChangeRowsPerPage: IHandleChangeRowsPerPage
}

const TableSubItens: React.FC<ITableSubItensProps> = ({
  data,
  refresh,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage
}) => {
  const { handleSelectItemForEdit, selectedItem } =
    useSecurityItensAndSubItens()
  const { setLoading } = useLoading()
  const { createCustomException, getException } = useException()
  const { showModal } = useModal()

  const handleDeleteSubItem = (selectedSubItem: IGetAllSubItensResponse) => {
    showModal({
      handleConfirm: () => {
        setLoading('loading')

        CadastroSegurancaItensSubItensServices()
          .deleteSubItem(selectedSubItem.idSubItemSeguranca)
          .then((response) => {
            if (response.status !== 200 || response.data.tipo) {
              const { tipo, detalhe, mensagem } = response.data

              createCustomException({
                detalhe,
                mensagem,
                tipo: IResponseTypes[tipo]
              })
            }

            showModal({
              hideButtonCancel: true,
              message: `SubItem ${selectedSubItem.nmSubItem} deletado com sucesso!`,
              txtButtonConfirm: 'OK',
              type: 'success'
            })
            refresh({
              idItemSeguranca: selectedItem.idItemSeguranca,
              pageNumber: 1
            })
            setLoading('idle')
          })
          .catch((err: Error) => {
            setLoading('idle')
            const error = getException(err)

            showModal({
              hideButtonCancel: true,
              message:
                error.mensagem ||
                err.message ||
                'Não foi possível deletar o item',
              txtButtonConfirm: 'OK',
              type: error.tipo || 'error'
            })
          })
      },
      message: `Tem certeza de que deseja deletar o item ${selectedSubItem.nmSubItem}?`,
      titleModal: 'Atenção!',
      txtButtonCancel: 'Cancelar',
      txtButtonConfirm: 'Sim',
      type: 'alert'
    })
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="20px"></TableCellStyled>
              <TableCellStyled minwidth="20px">SubItem</TableCellStyled>
              <TableCellStyled minwidth="20px">
                Descrição do Subitem
              </TableCellStyled>
              <TableCellStyled minwidth="50px" align="center">
                Infração
              </TableCellStyled>
              <TableCellStyled minwidth="50px">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {data?.entity?.items.length > 0 &&
              data?.entity?.items.map((row: IGetAllSubItensResponse) => (
                <TableRowStyled key={row.idItemSeguranca || '- - - - - - '}>
                  <TableCellStyled align="center">
                    {row.idVisualizacaoSubItem || '- - - - - - '}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row.nmSubItem || '- - - - - - '}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row.dsSubItem || '- - - - - - '}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.nuNivelInfracao || '- - - - - - '}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <EditIcon
                      fontSize="small"
                      onClick={() =>
                        handleSelectItemForEdit({ isSubItem: true, item: row })
                      }
                    />
                    <DeleteIcon
                      cursor="pointer"
                      onClick={() => handleDeleteSubItem(row)}
                    />
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={data?.entity?.items}
        totalItems={data?.entity?.pageCount}
        typeFooter="online"
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default TableSubItens
